<template>
  <li :class="`coupon_card_container ${isExpired ? 'coupon_expired' : ''}`">
    <CouponLabel :text="'오프라인 쿠폰'" />
    <div class="coupon_card_content_pending">
      <p class="heading_7">{{ title }}</p>
      <p class="body_9 f_gray_4" style="whiteSpace: pre-line">{{ memo }}</p>
      <p class="body_9 f_gray_4">{{ paymentDate }} ~ {{ expiryDate }}</p>
    </div>
    <Button
      :label="downYn=='Y' ? '쿠폰받기 완료' : '쿠폰 받기'"
      :disabled="downYn=='Y'"
      :size="44"
      :color="'secondary'"
      :onClick="handleCouponIssue"
    />
  </li>
</template>

<script>
import CouponLabel from '../label/CouponLabel.vue'
import Button from '../AiButton.vue'
import moment from 'moment'
export default {
  data () {
    return {
      isImminentExpired: false,
      isExpired: false,
      period: '',
      barcode: ''
    }
  },
  props: {
    couponSeq:{
      type:Number
    },
    title: {
      type: String
    },
    memo: {
      type: String
    },
    paymentDate: {
      type: String
    },
    expiryDate: {
      type: String
    },
    downYn: {
      type: String
    },
    onClickDownload:{
      type:Function
    }
  },
  methods: {
    handleCouponIssue () {
      this.onClickDownload(this.couponSeq);
    },
    setExpired() {
			const diffAt = moment.duration(
				moment(this.expiryDate).diff(undefined, 'second'),
				'second'
			)
			const diffDays = diffAt.asDays()
			const diffHours = diffAt.hours()
			const diffMinutes = diffAt.minutes()

			if (diffDays > 0) {
				if (diffDays <= 3) {
					this.isImminentExpired = true
					if (diffDays > 1) {
						this.period = `${diffAt.days()}일 후 만료`
					} else {
						this.period =
							diffHours > 0
								? `${diffHours}시간 ${diffMinutes}분 남음`
								: `${diffMinutes}분 남음`
					}
				} else {
					this.period = `${this.paymentDate} ~ ${this.expiryDate}`
				}
			} else {
				this.isExpired = true
				this.period = '만료'
			}
		},

  },
  components: {
    CouponLabel,
    Button
  },
  mounted: function () {
    this.setExpired()
  }
}
</script>


// WEBPACK FOOTER //
// src/components/ai/card/PendingCouponCard.vue